import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import styles from './css/Hint.scss';

export class ServiceSidebar extends Component {
    static propTypes = {
        order: ImmutablePropTypes.map.isRequired,
        services: ImmutablePropTypes.map.isRequired,
    }

    render() {
        const { order, services } = this.props;
        const serviceId = order.get('service');

        if (!serviceId) {
            return <span />;
        }

        const service = services.get(serviceId);
        const type = service.get('alias').split('.')[1];

        return (
            <p className={styles.hint}>
                <FormattedMessage id={`frontend.form_selector_service.label.${type}`} />
                {' '}
                <FormattedMessage id={`frontend.form_selector_service.hint.${type}`} />
            </p>
        );
    }
}

export default connect(state => ({
    order: state.order,
    services: state.services,
}))(ServiceSidebar);
